export default {
  statisticsTabInfo: state => state.statistics,
  forecastingTabInfo: state => state.forecasting,
  masterPageTabInfo: state => state.masterPage,
  mastersTableTabInfo: state => state.mastersTable,
  commonData: state => state.commonData,
  graphsSettings: state => state.graphsSettings,
}
